export const homeOrgs = [
    { label: 'HEB', value: 'HEB' },
    { label: 'WAKA KOTAHI', value: 'WAKA KOTAHI' },
    { label: 'FH', value: 'FH' },
    { label: 'ARMITAGE', value: 'ARMITAGE' },
    { label: 'BECA', value: 'BECA' },
    { label: 'WSP', value: 'WSP' },
    { label: 'SRG', value: 'SRG' },
    { label: 'RESOLVE', value: 'RESOLVE' },
    { label: 'TACTICAL', value: 'TACTICAL' },
    { label: 'MONARCHVA', value: 'MONARCHVA' },
    { label: 'SAFE SYS SOL', value: 'SAFE SYS SOL' },
    { label: 'Other', value: 'Other' }
];

export const departments = [
    { label: 'Auckland Harbour Bridge Asset Management', value: 'Auckland Harbour Bridge Asset Management' },
    { label: 'Auckland Harbour Bridge Delivery', value: 'Auckland Harbour Bridge Delivery' },
    { label: 'Alliance Leadership Team', value: 'Alliance Leadership Team' },
    { label: 'Asset Performance', value: 'Asset Performance' },
    { label: 'Commercial', value: 'Commercial' },
    { label: 'Communications and Stakeholder', value: 'Communications and Stakeholder' },
    { label: 'Compliance and Performance', value: 'Compliance and Performance' },
    { label: 'Corridor', value: 'Corridor' },
    { label: 'Delivery Excellence', value: 'Delivery Excellence' },
    { label: 'Delivery Optimisation', value: 'Delivery Optimisation' },
    { label: 'Environment and Sustainability', value: 'Environment and Sustainability' },
    { label: 'Health and Safety', value: 'Health and Safety' },
    { label: 'Journey Optimisation', value: 'Journey Optimisation' },
    { label: 'ASM Projects', value: 'ASM Projects' },
    { label: 'Network Controls', value: 'Network Controls' },
    { label: 'Network Controls - Permitting', value: 'Network Controls - Permitting' },
    { label: 'Network Operations', value: 'Network Operations' },
    { label: 'Network Safety', value: 'Network Safety' },
    { label: 'Operational Technology', value: 'Operational Technology' },
    { label: 'Pavement and Surfacing Asset', value: 'Pavement and Surfacing Asset' },
    { label: 'Pavements', value: 'Pavements' },
    { label: 'People and Culture', value: 'People and Culture' },
    { label: 'Planning', value: 'Planning' },
    { label: 'Quality, Systems and Processes', value: 'Quality, Systems and Processes' },
    { label: 'Risk', value: 'Risk' },
    { label: 'SRJ - CMJ', value: 'CMJ' },
    { label: 'Stormwater', value: 'Stormwater' },
    { label: 'Stormwater Asset', value: 'Stormwater Asset' },
    { label: 'Structures', value: 'Structures' },
    { label: 'Structures and Traffic Assets Delivery', value: 'Structures and Traffic Assets Delivery' },
    { label: 'Structures Asset', value: 'Structures Asset' },
    { label: 'Traffic and Corridor Asset', value: 'Traffic and Corridor Asset' },
    { label: 'Traffic Assets', value: 'Traffic Assets' },
    { label: 'Traffic Management Coordination', value: 'Traffic Management Coordination' },
    { label: 'Transport Technology and Tunnels', value: 'Transport Technology and Tunnels' },
    { label: 'Transport Technology Asset', value: 'Transport Technology Asset' },
    { label: 'TTM', value: 'TTM' },
    { label: 'TTM - CMJ', value: 'TTM - CMJ' },
    { label: 'TTM MLB', value: 'TTM MLB' },
    { label: 'TTM Reliable Way', value: 'TTM Reliable Way' },
    { label: 'Business Improvement', value: 'Business Improvement' },
];

export const widerTeams = {
    'Auckland Harbour Bridge Asset Management': "Asset and Network Performance",
    'Auckland Harbour Bridge Delivery': "Business Performance",
    'Alliance Leadership Team': 'ALT',
    'Asset Performance': 'Asset and Network Performance',
    'Commercial': 'Business Performance',
    'Communications and Stakeholder': 'Organisational Performance',
    'Compliance and Performance': 'Business Performance',
    'Corridor': 'Delivery Excellence',
    'Delivery Excellence': 'Delivery Excellence',
    'Delivery Optimisation': 'Delivery Excellence',
    'Environment and Sustainability': 'Business Performance',
    'Health and Safety': 'Organisational Performance',
    'Journey Optimisation': 'Asset and Network Performance',
    'ASM Projects': 'Delivery Excellence',
    'Network Controls': 'Asset and Network Performance',
    'Network Controls - Permitting': 'Asset and Network Performance',
    'Network Operations': 'Delivery Excellence',
    'Network Safety': 'Asset and Network Performance',
    'Operational Technology': 'Business Performance',
    'Pavement and Surfacing Asset': 'Asset and Network Performance',
    'Pavements': 'Delivery Excellence',
    'People and Culture': 'Organisational Performance',
    'Planning': 'Delivery Excellence',
    'Quality, Systems and Processes': 'Business Performance',
    'Risk': 'Business Performance',
    'Stormwater': 'Delivery Excellence',
    'Stormwater Asset': 'Asset and Network Performance',
    'Structures': 'Delivery Excellence',
    'Structures and Traffic Assets Delivery': 'Delivery Excellence',
    'Structures Asset': 'Asset and Network Performance',
    'Traffic and Corridor Asset': 'Delivery Excellence',
    'Traffic Assets': 'Delivery Excellence',
    'Traffic Management Coordination': 'Asset and Network Performance',
    'Transport Technology and Tunnels': 'Delivery Excellence',
    'Transport Technology Asset': 'Asset and Network Performance',
    'TTM': 'Delivery Excellence',
    'CMJ': 'Delivery Excellence',
    'TTM MLB': 'Delivery Excellence',
    'TTM Reliable Way': 'Delivery Excellence',
    'Business Improvement': 'Organisational Performance',
    'TTM - CMJ': 'Delivery Excellence',
};

export const workPlaces = [
    { label: 'Office', value: 'Office' },
    { label: 'Remote', value: 'Remote' },
    { label: 'Field', value: 'Field' },
];

export const shiftTypes = [
    { label: 'Night', value: 'night' },
    { label: 'Day', value: 'day' },
];

export const advertisingTypes = [
    { label: 'Internal', value: 'Internal' },
    { label: 'External', value: 'External' },
];

export const incomeTypes = [
    { label: 'Salary', value: 'Salary' },
    { label: 'Wages', value: 'Wages' },
];

export const salaryTimeFrames = [
    { label: 'Year', value: 'year' },
    { label: 'Hour', value: 'hour' },
];

export const contractTypes = [
    { label: 'Permanent', value: 'Permanent' },
    { label: 'Fixed', value: 'Fixed' },
    { label: 'Casual', value: 'Casual' },
    { label: 'Volunteer', value: 'Volunteer' }
];

export const benefits = [
    { label: 'Vehicle', value: 'Vehicle' },
    { label: 'Fuel card', value: 'Fuel card' },
];

export const laboursHire = [
    { label: 'Fulton Hogan', value: 'Fulton Hogan' },
    { label: 'HEB', value: 'HEB' },
    { label: 'Stella', value: 'Stella' },
    { label: 'Superior Recruitment', value: 'Superior Recruitment' },
    { label: 'One Staff', value: 'One Staff' },
    { label: 'Remarkable People', value: 'Remarkable People' },
    { label: 'Other', value: 'Other' },
];

export const systemsAccess = [
    { label: 'Vault', value: 'Vault' },
    { label: 'Timesheet', value: 'Timesheet' },
    { label: 'Login', value: 'Login' },
    { label: 'RAMM', value: 'RAMM' },
    { label: 'Plasma', value: 'Plasma' },
    { label: 'CRM', value: 'CRM' },
];

export const accesories = [
    { label: 'Building Access Card Ellerslie', value: 'Building Access Card Ellerslie' },
    { label: 'Carpark Access Card Ellerslie', value: 'Carpark Access Card Ellerslie' },
    { label: 'Advanced computer', value: 'Advanced computer' },
    { label: 'General computer', value: 'General computer' },
    { label: 'Tablet', value: 'Tablet' },
    { label: 'Phone', value: 'Phone' },
];

export const ppe_ppc = [
    { label: 'Hard Hat', value: 'Hard Hat' },
    { label: 'Hi Viz', value: 'Hi Viz' },
    { label: 'Gloves', value: 'Gloves' },
    { label: 'Glasses', value: 'Glasses' },
    { label: 'Earmuffs', value: 'Earmuffs' },
    { label: 'Wet Weather Gear', value: 'Wet Weather Gear' },
    { label: 'Safety Boots', value: 'Safety Boots' },
];

export const fullTimeEquivalents = [
    { label: '1.0', value: '1.0' },
    { label: '0.9', value: '0.9' },
    { label: '0.8', value: '0.8' },
    { label: '0.7', value: '0.7' },
    { label: '0.6', value: '0.6' },
    { label: '0.5', value: '0.5' },
    { label: '0.4', value: '0.4' },
    { label: '0.3', value: '0.3' },
    { label: '0.2', value: '0.2' },
    { label: '0.1', value: '0.1' },
    { label: '0.0', value: '0.0' },
];